var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBotsonicLogoGrey = function SvgBotsonicLogoGrey(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M13.44 4.931h-2.493V3.414a1.743 1.743 0 0 0 1.264-1.672C12.211.782 11.43 0 10.47 0a1.742 1.742 0 0 0-.477 3.414V4.93H7.394a6.277 6.277 0 0 0-6.269 6.27c0 1.45.506 2.85 1.411 3.961.985 1.21 1.898 2.475 2.798 3.748l.258.364c.327.461.835.726 1.395.726.967 0 1.726-.755 1.726-1.719v-.81h4.833a6.276 6.276 0 0 0 6.268-6.39c-.066-3.431-2.94-6.147-6.373-6.147V4.93h-.001Zm-3.758-3.19a.788.788 0 1 1 1.576 0 .788.788 0 0 1-1.576 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M13.546 5.885h-6.15a5.315 5.315 0 0 0-4.114 8.682l2.008 2.626 1.082 1.528c.43.607 1.386.303 1.386-.441v-1.764h5.788a5.315 5.315 0 0 0 0-10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M14.158 13.565H6.782a2.331 2.331 0 0 1 0-4.662h7.376a2.331 2.331 0 0 1 0 4.662Z",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.007 12.12a.886.886 0 1 0 0-1.772.886.886 0 0 0 0 1.772Zm-5.076 0a.886.886 0 1 0 0-1.772.886.886 0 0 0 0 1.772Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.507,
    x2: 18.991,
    y1: 2.474,
    y2: 19.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.071,
    x2: 20.42,
    y1: 3.815,
    y2: 20.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBotsonicLogoGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/botsonic-logo-grey.2d96e4ccbda16d11ed6df17e53e28010.svg";